import { featuredWorks } from '@/mocks/data';

export default function FeaturedWorksSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          精选作品
        </h2>
        <p className="mt-2 text-sm text-foreground-500">来自社区创作者的优秀作品展示</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {featuredWorks.map((work) => (
          <div
            key={work.id}
            className="group relative rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full h-64 overflow-hidden">
              <img
                src={work.image}
                alt={work.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="text-xs text-background-50/80">{work.category}</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-base font-semibold text-foreground-900 mb-1">{work.title}</h3>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{work.author}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-line"></i>
                  {work.likes >= 1000 ? `${(work.likes / 1000).toFixed(1)}k` : work.likes}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}